<template>
  <outro-template status="success" :hide-content="true" :show-exit-button="true" :memo="{ label: 'Heures excédentaires / déficitaires', link: 'files/memo1_heures_exedentaires.pdf' }">
    <template v-slot:title>
      Déclarer du temps de travail supplémentaire
    </template>
  </outro-template>
</template>

<script>
import OutroTemplate from '@shared/components/OutroTemplate'

export default {
  name: 'Outro',
  components: {
    OutroTemplate
  }
}
</script>

<style lang="scss">

</style>
